import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    reservation: null,
    quoteRequest: {
      user: {
        emailAddress: `fakelosuser@example.com`,
        firstName: 'Fake',
        lastName: 'User',
        phoneNumber: '5551234567',
        address: {
          street: '1600 Pennsylvania Avenue NW',
          city: 'Washington',
          state: 'DC',
          zip: '20500'
        }
      },
      car: {
        vin: 'WDDGF4HBXEA966339',
        milesPerYear: 7000,
        odometer: 32000,
        yearsToOwn: 5,
        flags: {
          commercialUse: false,
          certifiedPreowned: true,
          secondOwner: true,
          hasLiftKitOrOversizeTires: false,
          modifiedVehicle: false,
          isSalvageTitle: false
        }
      }
    },
    apis: {
      integratorId: 'demo',
      swbcOrigin: 'https://web.devmktapp.com',
      integratorOrigin: 'https://devfakelos.com',
      institutionId: '9a175661-f00d-4697-9b6e-f80bb4a06964'
    }
  },
  getters: {
    randomPostfixedEmail (state) {
      return state.quoteRequest.user && state.quoteRequest.user.emailAddress && state.quoteRequest.user.emailAddress.replace('@', `+${Math.floor(Math.random() * 1000 * 1000 * 1000)}@`)
    },
    quoteRequest (state) {
      return state.quoteRequest
    },
    institutionId (state) {
      return state.apis.institutionId
    },
    integratorOrigin (state) {
      return state.apis.integratorOrigin
    },
    swbcOrigin (state) {
      return state.apis.swbcOrigin
    },
    integratorId (state) {
      return state.apis.integratorId
    },
    apis (state) {
      return state.apis
    },
    reservation (state) {
      return state.reservation
    }
  },
  mutations: {
    SET_QUOTE_REQUEST (state, quoteRequest) {
      state.quoteRequest = quoteRequest
    },
    SET_APIS (state, apis) {
      state.apis = apis
    },
    SET_RESERVATION (state, reservation) {
      state.reservation = reservation
    }
  },
  actions: {
    setQuoteRequest ({ dispatch, commit, state }, quoteRequest) {
      commit('SET_QUOTE_REQUEST', quoteRequest)
    },
    setApis ({ commit }, apis) {
      commit('SET_APIS', apis)
    },
    setReservation ({ commit }, reservation) {
      commit('SET_RESERVATION', reservation)
    }
  }
})
